module.exports = __webpack_public_path__ + "img/sound-off.9f445cbb.svg";